<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10cQZsI/tc-custom/cover.jpg?1685327424734?1692044794246" alt="This image is the cover for the book Smoke and Dreams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smoke and Dreams
      </h1>
      <p class="bookDescription body article font2">
        <p>The last place medium and artist's model Tally Munro wants to be is Galveston, Texas, in 1908. After the terrible hurricane devastated the island, killing thousands, ghosts assail her with their cries for help. But her fiancê, artist Crispin Reid, has asked her to join him and his new friend, businessman and inventor, Angus McClaren at the Reid summer home.<br/><br/>Angus is a pragmatist and dubious about the reality of spirits. But he's willing to join the couple in their spiritual venture, plus he's interested in both Tally and Crispin -- and not just as friends.<br/><br/>Cris is a romantic and just wants them all to get along -- really well. With the help of one of Angus's inventions, they take on the spirits of the hurricane and their feelings for one another.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhozwyn Darius
      </h2>
      
      <p class="authorDescription body article">Rhozwyn Darius is an erotic romance writer who makes jewelry, re-enacts the Middle Ages, and spends time with steampunks, among other things. She knows life is far more full of magic than we humans tend to notice, and thinks love comes in all sorts of shapes and sizes and so do families -- especially the non-traditional ones. True love is expansive, growing larger as it’s shared. Plus, she really, really loves a happy ending.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e54899c